<script lang="ts">
	import type { PageData } from './$types';
	import Pagination from '$lib/components/Pagination.svelte';
    import {LL as l} from '$lib/i18n/i18n-svelte'
	import { enhance } from '$app/forms';
	import { queryParameters } from "sveltekit-search-params";
	
	const query = queryParameters();

	export let data: PageData;
	export let form: ActionData;

    let lang:'en'|'el'=data.locale
	// console.log(data)
	let count=0
	count = Math.floor(data.count/52)
	$: if (form?.success) {
		$query.sort=form.sort;
		data = form;
	}
</script>
<svelte:head>
    <title>{data.currentCat?.name?.[lang]}</title>
</svelte:head>
<!-- <div class="container mx-auto my-12">Προϊόντα</div>
<div class="container mx-auto flex justify-start flex-wrap">
	{#each data.data as product}
		<a href="/s/{product.id}/{product.url}">
			<div
				class="p-3 rounded-md shadow bg-white hover:shadow-xl hover:transform hover:scale-105 duration-300 m-4 w-60"
			>
				<img
					alt=""
					class="w-full h-52 rounded-md mx-auto"
					src="/images/thumb/{product.image ? product.image : 'cronuslogo.png'}"
				/>
				<div class="mt-2 mb-1 h-12 font-semibold text-slate-500">
					<p class="line-clamp-2">{product.name}</p>
				</div>
			</div>
		</a>
	{/each}
</div>-->
<!-- Create By Joker Banny -->
<div class="bg-white w-full">
	<!-- Header Navbar -->


	<!-- Title -->
	<div class="pt-10 bg-white">
		<h1 class="text-center text-2xl font-bold text-gray-800">{data.currentCat?.name?.[lang]}</h1>
	</div>

	<!-- Tab Menu -->
	<div
		class="flex flex-wrap items-center overflow-x-auto overflow-y-hidden py-10 justify-center bg-white text-gray-800"
	>
		<span class="text-lg pr-4">Ταξινόμηση:</span>
		<!-- <form action="?/sortingAsc" method="post" use:enhance> -->
			<a href="?sort=ascName" class="flex items-center flex-shrink-0 pl-2 py-3 text-gray-600 {$query.sort=='ascName'?'text-primary':''}">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
					<path stroke-linecap="round" stroke-linejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
				  </svg>			  
				<!-- <span>Όνομα</span> -->
			</a>
			<a href="?sort=descName" class="flex items-center flex-shrink-0 pr-2 py-3 text-gray-600 {$query.sort=='descName'?'text-primary':''}">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
					<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
				  </svg>			  
				<!-- <span>Όνομα</span> -->
			</a>
		<!-- </form> -->
		<span>Όνομα</span>
		<!-- <form action="?/sortingDesc" method="post" use:enhance> -->

		<!-- </form> -->
		<!-- <form action="?/sortingAscPrice" method="post" use:enhance> -->
			<a href="?sort=ascPrice" class="flex items-center flex-shrink-0 pl-3 py-3 text-gray-600 {$query.sort=='ascPrice'?'text-primary':''}">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
					<path stroke-linecap="round" stroke-linejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
				  </svg>			  
				<!-- <span>Τιμή</span> -->
			</a>
			<a href="?sort=descPrice" class="flex items-center flex-shrink-0 pr-2 py-3 text-gray-600 {$query.sort=='descPrice'?'text-primary':''}">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
					<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
				  </svg>			  
				<!-- <span>Τιμή</span> -->
			</a>
		<!-- </form> -->
		<span>Τιμή</span>
		<!-- <form action="?/sortingDescPrice" method="post" use:enhance> -->

		<!-- </form> -->

		<!-- <a
			rel="noopener noreferrer"
			href="#"
			class="flex items-center flex-shrink-0 px-5 py-3 space-x-2text-gray-600"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="w-4 h-4"
			>
				<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
			</svg>
			<span>-</span>
		</a>
		<a
			rel="noopener noreferrer"
			href="#"
			class="flex items-center flex-shrink-0 px-5 py-3 space-x-2 rounded-t-lg text-gray-900"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="w-4 h-4"
			>
				<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
				<path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
			</svg>
			<span>-</span>
		</a>
		<a
			rel="noopener noreferrer"
			href="#"
			class="flex items-center flex-shrink-0 px-5 py-3 space-x-2 text-gray-600"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="w-4 h-4"
			>
				<polygon
					points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
				></polygon>
			</svg>
			<span>-</span>
		</a>
		<a
			rel="noopener noreferrer"
			href="#"
			class="flex items-center flex-shrink-0 px-5 py-3 space-x-2 text-gray-600"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="w-4 h-4"
			>
				<circle cx="12" cy="12" r="10"></circle>
				<polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
			</svg>
			<span>-</span>
		</a> -->
	</div>

	<!-- Product List -->
	<section class="py-10 bg-gray-100" data-sveltekit-preload-data='hover'>
		<div
			class="mx-auto grid max-w-7xl grid-cols-1 gap-6 p-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
		>
			{#each data.data as product}
				<article
					class="rounded-xl bg-white p-3 shadow-lg hover:shadow-xl hover:transform hover:scale-105 duration-300"
				>
					<a href="/s/{product.id}/{product.url}">
						<div class="relative flex items-end overflow-hidden rounded-xl">
							<img
								src="/images/thumb/{product.image ? product.image : 'cronuslogo.png'}"
								alt="product"
								class="mx-auto"
							/>
							<!-- <div
								class="flex items-center space-x-1.5 rounded-lg bg-blue-500 px-4 py-1.5 text-white duration-100 hover:bg-blue-600"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									class="h-4 w-4"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
									/>
								</svg>

								<button class="text-sm">Add to cart</button>
							</div> -->
						</div>

						<div class="mt-1 p-2">
                            <div class="bg-primary text-gray-50 font-semibold text-sm px-1.5 py-0-.5 w-fit rounded shadow">
                                {product.manufacturer[0]?.name?product.manufacturer[0].name:'OEM'}
                            </div>
							<h2 class="text-slate-700 line-clamp-2 my-2 font-medium" title="{product.name[lang]?product.name[lang]:product.name.el}">{product.name[lang]?product.name[lang]:product.name.el}</h2>
							<!-- <p class="mt-1 text-sm text-slate-400"> -->
                                {#if product.availability==0}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-red-500 text-white rounded-md">Εκτός αποθέματος</div>
                                {:else if product.availability==1}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-green-500 text-white rounded-md">Διαθέσιμο</div>
                                {:else if product.availability==2}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-indigo-500 text-white rounded-md">Κατόπιν παραγγελίας</div>
                                {:else if product.availability==3}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-indigo-500 text-white rounded-md">Διαθέσιμο εντός 3 ημερών</div>
                                {:else if product.availability==10}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-indigo-500 text-white rounded-md">Διαθέσιμο εντός 10 ημερών</div>
                                {:else}
                                <div class="px-1 py-0.5 w-full text-center text-sm bg-indigo-500 text-white rounded-md">Διαθέσιμο εντός 30 ημερών</div>
                                {/if}
                            <!-- </p> -->

							<div class="mt-3 flex items-end justify-between">
								<!-- <p class="text-lg font-bold text-blue-500">$850</p> -->
                                <div class="">
                                    <span class="text-primary {product.validOffer?'line-through decoration-3 decoration-red-600 text-sm font-semibold italic':'text-lg font-bold'}">{product.price?product.price.toFixed(2):''}€</span>
                                    {#if product.validOffer}
                                        <span class="text-primary text-lg font-bold">{product.specialPrice?product.specialPrice.toFixed(2):''}€</span>
                                    {/if}
                                    <!-- {#if product.priceIncludeVat}
                                        <span class="text-slate-500 text-sm">+ {product.vat}%</span>
                                    {/if}
                                    {#if product.percentageOffer}
                                        <span class="text-white rounded-xl bg-red-500 text-lg ml-4 px-1 py-2 font-medium">↓{product.percentageOffer}%</span>
                                    {/if} -->
                                </div>


								<div
									class="flex items-center space-x-1.5 rounded-lg bg-primary px-4 py-1.5 text-white duration-100 hover:bg-primary"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke-width="1.5"
										stroke="currentColor"
										class="h-4 w-4"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
										/>
									</svg>

									<button class="text-sm">Add to cart</button>
								</div>
							</div>
						</div>
					</a>
				</article>
			{/each}
		</div>
		{#if !data.data.length }
        <div class="text-center w-full">
            {$l.productsNotFound()}
        </div>
        {/if}
		<div class="flex justify-end max-w-7xl mx-auto pr-4">
			<Pagination count={count} pageNo={data.pageNo}/>
		</div>
	</section>
</div>
